export const USE_MOCKS =
  typeof import.meta !== "undefined" &&
  (import.meta.env.VITE_USE_MOCKS === "1" ||
    import.meta.env.VITE_USE_MOCKS === "true");

function computeBase() {
  const raw = (typeof import.meta !== "undefined" && (import.meta.env.VITE_API_BASE as string | undefined)) || "/api/v1";

  try {
    // Absolute URL
    const u = new URL(raw, window.location.origin);
    const baseUrl = `${u.protocol}//${u.host}`;
    const basePath = u.pathname.replace(/\/$/, "");
    return { baseUrl, basePath };
  } catch {
    // Relative path like /api/v1
    return { baseUrl: "", basePath: raw.replace(/\/$/, "") };
  }
}

const { baseUrl, basePath } = computeBase();

export const API_BASE_URL = baseUrl;
export const API_BASE_PATH = basePath;
